import { useGetFeatureFlags } from '~/api';

export function useIsTraderEnabled(): boolean {
  const { data } = useGetFeatureFlags();
  return (data?.featureFlags ?? []).some(
    (flag) => flag.name === 'TRADER' && flag.enabled
  );
}
